import moveOver from './move-over.js';

function toUp (opts) {
  return moveOver.call(this, 'y', -1, opts);
}

export { toUp as default };
//# sourceMappingURL=to-up.js.map
